import { defaultFullscreenPageStyling } from "@/theme";
import { convertPxToRem } from "@/utils";
import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import IconLoader from "../IconLoader";

export default function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack
      spacing={5}
      justifyContent="center"
      minHeight="100vh"
      sx={{ ...defaultFullscreenPageStyling }}
    >
      <Stack alignItems="center" spacing={2}>
        <IconLoader
          icon="QuestionMarkIcon"
          sx={{ fontSize: convertPxToRem(110) }}
        />
        <Typography variant="h1" textAlign="center">
          {t("NotFound.title")}
        </Typography>
        <Typography variant="body1" textAlign="center" color="neutral.main">
          {t("NotFound.subtitle")}
        </Typography>
      </Stack>

      <Button
        variant="contained"
        onClick={() => navigate("/", { replace: true })}
      >
        {t("common.goHomeButton")}
      </Button>
    </Stack>
  );
}
